import { render, staticRenderFns } from "./ReservationNewPerson.vue?vue&type=template&id=1a4cc119&lang=true"
import script from "./ReservationNewPerson.vue?vue&type=script&lang=js"
export * from "./ReservationNewPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports